export default __webpack_public_path__ + "static/media/page-title-bg-04.e7be1f1b.jpg";